import { useEffect, useState } from 'react';

// Animation styles shared by the video-story and storybook creation flows.
// The backend is the source of truth (GET /stories/animation-styles); this
// is the offline/first-paint fallback.
const STYLE_PREVIEW_BASE = 'https://huzyagtfxwapsccsksib.supabase.co/storage/v1/object/public/videos/assets/style_previews';
export const ANIMATION_STYLE_FALLBACK = [
  { id: 'cgi', label: '3D Animation', tagline: 'Bright, rounded, Pixar-style 3D — the classic Pixley look.', preview_url: `${STYLE_PREVIEW_BASE}/cgi.jpg` },
  { id: '2d', label: '2D Cartoon', tagline: 'Flat, clean, modern TV cartoon — think Bluey.', preview_url: `${STYLE_PREVIEW_BASE}/2d.jpg` },
  { id: 'anime', label: 'Anime', tagline: 'Hand-drawn, painterly worlds — Ghibli-inspired.', preview_url: `${STYLE_PREVIEW_BASE}/anime.jpg` },
  { id: 'felt', label: 'Felt Puppets', tagline: 'Cosy needle-felted wool, like a handmade puppet show.', preview_url: `${STYLE_PREVIEW_BASE}/felt.jpg` },
];

export const DEFAULT_ANIMATION_STYLE = 'cgi';

// Rollout gate for the picker. Open to everyone since 2026-10-02 (iOS opened
// 2026-09-17); it was @pixleyai.com-only while the styles were being tuned.
// Kept as the single switch: REACT_APP_ANIMATION_STYLES=off hides it again.
// eslint-disable-next-line no-unused-vars
export function animationStylesEnabledFor(user) {
  return process.env.REACT_APP_ANIMATION_STYLES !== 'off';
}

/**
 * Options for the picker: the fallback list until the backend catalogue
 * arrives. Fetches only when `enabled` (the picker is gated) and an
 * apiClient exists; a failed fetch silently keeps the fallback.
 */
export function useAnimationStyleOptions(apiClient, enabled) {
  const [options, setOptions] = useState(ANIMATION_STYLE_FALLBACK);

  useEffect(() => {
    if (!apiClient || !enabled) return undefined;
    let alive = true;
    apiClient.getAnimationStyles()
      .then((res) => {
        const list = res?.data || res;
        if (alive && Array.isArray(list) && list.length) setOptions(list);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [apiClient, enabled]);

  return options;
}
